<template>
    <div class="mobile-wallets-checkout py-1">
        <div v-if="loading" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="blue darken-3" size="30" width="2"></v-progress-circular>
        </div>
        <div v-else-if="checkingOut" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="yellow darken-3" size="30" width="2"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        amount: {
            required: true,
        }
    },
    data(){
        return {
            loading: false,
            checkingOut: false,
            iframeUrl: null,
            imported: false,
            
            chargeRequest: null,
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    methods: {
        ...GlobalMethods,
        initOrder(){
            if (!this.loading){
                this.loading = true;
                  
                this.$store.dispatch('createFawryOrder', {amount: this.amount}).then(response=>{
                    setTimeout(()=>{
                        this.chargeRequest = response.data;
                        this.loading = false;
                        this.checkout();
                    }, 1000);

                }).catch(e=>{
                    console.error(e)
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، حاول مرة أخرى', 'error');
                })
            }
        },
        importFawryLibs(){
            if (!this.imported){ 
                let script = document.createElement('script');
                script.setAttribute('type', 'text/javascript');
                // script.setAttribute('src', `https://atfawry.fawrystaging.com/atfawry/plugin/assets/payments/js/fawrypay-payments.js`) // testing
                script.setAttribute('src', `https://www.atfawry.com/atfawry/plugin/assets/payments/js/fawrypay-payments.js`) // prod
                document.head.appendChild(script);

                script.onload = ()=>{
                    this.initOrder();
                    this.imported = true;
                }
    
    
                // let link = document.createElement('link');
                // link.setAttribute('rel', 'stylesheet');
                // link.setAttribute('src', `https://atfawry.fawrystaging.com/atfawry/plugin/assets/payments/css/fawrypay-payments.css`)
                // document.head.appendChild(link);
    
            }
        },
        checkout(){
            const configuration = {
                locale : "ar",  //default en
                // mode: DISPLAY_MODE.SIDE_PAGE, // eslint-disable-line no-undef
                mode: DISPLAY_MODE.POPUP, // eslint-disable-line no-undef
                // mode: DISPLAY_MODE.SEPERATED, // eslint-disable-line no-undef
            };
            this.checkingOut = true;
            FawryPay.checkout(this.chargeRequest, configuration); // eslint-disable-line no-undef
        }
    },
    mounted(){
        /* if (!this.iframeUrl){
            this.initPaymob();
        } */
    //    this.initOrder();
       this.importFawryLibs();
    }
}
</script>

<style lang="scss">
@import url('https://atfawry.fawrystaging.com/atfawry/plugin/assets/payments/css/fawrypay-payments.css');
.mobile-wallets-checkout{
    .v-messages{
        min-height: 18px!important;
    }
}
</style>